/**
 * Gemeinsame Einstellungen aller Sprechblasen (Ticket #127, 12.10.2026).
 *
 * Verzögerung: Sprechblasen erscheinen erst, wenn der Mauszeiger kurz auf dem
 * Element ruht — nicht schon beim Vorbeistreifen. Das (?)-Symbol ist eine
 * ausdrückliche Bitte um Hilfe und kommt deshalb schneller (F3 = b).
 *
 * Strategie "fixed": Eine absolut positionierte Sprechblase hängt am <body>
 * und vergrößert im ersten Frame (bevor Popper sie platziert hat) die
 * Scrollfläche des Dokuments. Unter Windows blitzt dann rechts eine
 * Bildlaufleiste auf und alles zuckt. Fixierte Elemente zählen nicht zur
 * Scrollfläche. Das Dokument selbst scrollt im Ordermanagement nirgends
 * (gescrollt wird innen), deshalb sitzen sie an derselben Stelle.
 */
export const TOOLTIP_DELAY = {show: 700, hide: 100};

export const HELP_TOOLTIP_DELAY = {show: 300, hide: 100};

/**
 * @param {object[]} [modifiers]
 * @returns {{strategy: string, modifiers: object[]}}
 */
export function fixedPopper(modifiers = []) {
    return {strategy: 'fixed', modifiers};
}
